import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { joinURL, withQuery } from "ufo";
import { url } from "../constants/constants";
import * as sessionService from "./session";
import { axiosPrivate } from "./axiosPrivate";

const API_URL = url;

export class HttpError extends Error {
  constructor(status, message, info) {
    super(message ?? "Internal Server Error");
    this.name = "HttpError";
    this.status = status;
    this.info = info ?? {};
  }
}

function getHeaders({ data, accessToken, headers: customHeaders }) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...customHeaders,
  };

  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`;
  }

  if (data instanceof FormData) {
    delete headers["Content-Type"];
  }

  return headers;
}

function getBody(data) {
  if (data) {
    return data;
  }

  return undefined;
}
/**
 * HTTP request with several thing already configured
 */
export async function http(endpoint, requestInit = {}) {
  const { signal, abort } = new AbortController();
  const {
    baseURL,
    data,
    params = {},
    headers: customHeaders,
    accessToken = sessionService.getSession(sessionService.ACCESS_TOKEN_KEY),
    customMessage,
    ...customConfig
  } = requestInit ?? {};

  const baseUrl = baseURL ?? API_URL;
  const url = baseUrl ? joinURL(baseUrl, endpoint) : endpoint;
  const urlWithQuery = withQuery(url, params);

  const config = {
    signal,
    method: data ? "POST" : "GET",
    data: getBody(requestInit.data),
    headers: getHeaders({ ...requestInit, accessToken }),
    ...customConfig,
  };

  try {
    return await axiosPrivate(urlWithQuery, config);
  } catch (error) {
    const result = {
      errorMessage: "알수 없는 오류가 발생했습니다.",
    };

    if (isAxiosError(error)) {
      result.errorMessage = error?.response?.data?.error?.code;
    }

    toast.error(result.errorMessage, {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  }
}
